<details #detailsElement (toggle)="onToggle($event)" [class.opacity-50]="disabled()" [class.pointer-events-none]="disabled()">
  <summary
    class="p-6 md:py-6 md:px-[2.5rem] border-vinciBlue-250 border-1 flex flex-col gap-6 md:flex-row md:justify-between bg-vinciLavender md:rounded-xl rounded-lg hover:cursor-pointer group"
    [class.rounded-b-none]="isDetailsOpen()"
    [class.md:rounded-b-none]="isDetailsOpen()"
  >
    <h4 class="my-auto">{{name()}}</h4>
    <div class="flex flex-col md:flex-row gap-2 md:gap-10 md:items-center">
      <p class="font-thin">
        {{countSelectedFilters()}} {{countSelectedFilters() > 1 ?
        ('components.filterSection.manyFiltersSelectedText' | transloco):
        ('components.filterSection.oneFilterSelectedText' | transloco) }}
      </p>
      @if(isDetailsOpen()){
      <div
        class="px-2 rounded-full bg-vinciBlue-150 group-hover:bg-vinciBlue-250 transition-colors duration-200"
      >
        <icon
          [name]="'nav-arrow-up'"
          [size]="'0.875rem'"
          class="mobile-hidden mt-2"
        />
      </div>
      } @else {
      <div
        class="px-2 rounded-full bg-vinciBlue-150 group-hover:bg-vinciBlue-250 transition-colors duration-200"
      >
        <icon
          [name]="'nav-arrow-down'"
          [size]="'0.875rem'"
          class="mobile-hidden mt-2"
        />
      </div>
      }
      <p class="desktop-hidden cta text-vinciBlue-600 self-end">
        {{isDetailsOpen() ? ('components.filterSection.hideFilters' | transloco)
        : ('components.filterSection.fineTuneSelection' | transloco)}}
        <icon [name]="'plus-circle-empty'"></icon>
      </p>
    </div>
  </summary>
  <div class="p-6 md:p-10 rounded-b-xl bg-white">
    @if(filter().filtersCategories?.length > 0 && !showSearchBar()) {
    <div class="flex flex-wrap items-center gap-1 mb-6" #categoriesContainer>
      @for(category of filter().filtersCategories; track $index) {
      <button
        #categoryButton
        [attr.data-sp-id]="category.spId"
        class="flex flex-1 w-[17.5rem] items-center gap-2 h-[2.625rem] px-2 rounded-lg border border-vinciGrey-300 text-vinciBlue cursor-pointer hover:bg-vinciGrey-50 transition-colors duration-200"
        (click)="selectCategory(category, categoryButton)"
      >
        <span class="text-left w-100">{{ category.translation }}</span>
      </button>
      }
    </div>
    }
    <div class="flex gap-3 md:gap-8 mb-6" [class.flex-wrap]="!showSearchBar()" [class.flex-col]="showSearchBar()">
      @if(showSearchBar()) {
      <input
        #searchInput
        class="h-[2.625rem] px-4 rounded-lg border border-vinciBlue-300 text-vinciBlue bg-white focus:outline-none focus:ring-2 focus:ring-vinciBlue-300 focus:border-transparent"
        type="text"
        [placeholder]="searchBarPlaceholder()"
        [value]="searchBarValue()"
        (input)="onSearchInput($event)"
      />
      }
      @if(filter().filtersCategories.length !== 0) {
      @if(categoriesSelected().length > 0) {
      <app-button
        [text]="'components.filterSection.selectAll' | transloco"
        [variant]="'quinary'"
        (buttonClick)="selectAll()"
      ></app-button>
      <app-button
        [text]="'components.filterSection.unselectAll' | transloco"
        [variant]="'quinary'"
        (buttonClick)="deselectAll()"
      ></app-button>
      } } @else {
      <app-button
        [text]="'components.filterSection.selectAll' | transloco"
        [variant]="'quinary'"
        (buttonClick)="selectAll()"
      ></app-button>
      <app-button
        [text]="'components.filterSection.unselectAll' | transloco"
        [variant]="'quinary'"
        (buttonClick)="deselectAll()"
      ></app-button>
      } @if(activateSearchBar() && !showSearchBar()) {
      <app-button
        [text]="activateSearchBarText()"
        [icon]="'search'"
        [iconSize]="'1.125rem'"
        (buttonClick)="toggleSearchBar()"
      ></app-button>
      } @if(activateSearchBar() && showSearchBar()) {
      <app-button
        [text]="disableSearchBarText()"
        [icon]="'search'"
        [iconSize]="'1.125rem'"
        (buttonClick)="toggleSearchBar()"
      ></app-button>
      }
    </div>
    <div
      class="flex flex-wrap gap-2 max-h-[8.5rem] overflow-y-auto filters-scrollbar"
      #filtersContainer
    >
      @if (!showSearchBar()) { @for(filter of filter().filters; track $index) {
      <button
        #filterButton
        [attr.data-sp-id]="filter.spId"
        class="flex items-center gap-2 h-[2.625rem] px-2 rounded-lg bg-vinciBlue-25 border border-vinciBlue-300 text-vinciBlue cursor-pointer hover:bg-vinciBlue-150 transition-colors duration-200"
        (click)="this.clickFilter(filter, filterButton)"
      >
        {{ filter.translation }}
        <icon
          [name]="filtersSelected().includes(filter) ? 'cross-circle-empty' : 'plus-circle-empty'"
          [size]="filtersSelected().includes(filter) ? '1.1875rem' : '1rem'"
          [color]="'text-vinciBlue-600'"
        ></icon></button
      >} @for(category of categoriesSelected(); track $index) {@for(filter of
      category.filters; track $index) {
      <button
        #filterButton
        [attr.data-sp-id]="filter.spId"
        class="flex items-center gap-2 h-[2.625rem] px-2 rounded-lg bg-vinciBlue-25 border border-vinciBlue-300 text-vinciBlue cursor-pointer hover:bg-vinciBlue-150 transition-colors duration-200"
        (click)="this.clickFilter(filter, filterButton)"
      >
        {{ filter.translation }}
        <icon
          [name]="filtersSelected().includes(filter) ? 'cross-circle-empty' : 'plus-circle-empty'"
          [size]="filtersSelected().includes(filter) ? '1.1875rem' : '1rem'"
          [color]="'text-vinciBlue-600'"
        ></icon>
      </button>
      }} }
    </div>
  </div>
</details>
